import { MenuItem, Select } from '@mui/material';
import { ComponentProps, FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { MetricBehavior } from '../../gql/graphql';

type Props = ComponentProps<typeof Select<MetricBehavior>>;

const MetricBehaviorSelect: FC<Props> = ({ value, ...props }) => (
	<Select {...props} value={value ?? '' /* value cannot be undefined in order to keep the input controlled */}>
		<MenuItem value={'latest'}>
			<FormattedMessage id={'form.metric.behavior.latest'} />
		</MenuItem>
		<MenuItem value={'sum'}>
			<FormattedMessage id={'form.metric.behavior.sum'} />
		</MenuItem>
		<MenuItem value={'average'}>
			<FormattedMessage id={'form.metric.behavior.average'} />
		</MenuItem>
		<MenuItem value={'proportion'}>
			<FormattedMessage id={'form.metric.behavior.proportion'} />
		</MenuItem>
	</Select>
);

export { MetricBehaviorSelect };
